import { t } from '@/i18n/translations';

/**
 * Devolve YYYY-MM-DD para um ``Date`` ou string ISO.
 * Usado pelo PeriodPicker do dashboard.
 */
export function toIsoDate(value) {
  if (!value) return '';
  if (typeof value === 'string') return value.slice(0, 10);
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString().slice(0, 10);
  }
  return '';
}

export function formatRangeLabel(from, to, lang) {
  if (!from || !to) return t('period_custom', lang);
  const locale = lang === 'pt' ? 'pt-PT' : lang === 'fr' ? 'fr-FR' : 'en-GB';
  try {
    const f = new Date(from).toLocaleDateString(locale);
    const t2 = new Date(to).toLocaleDateString(locale);
    return `${f} – ${t2}`;
  } catch {
    return t('period_custom', lang);
  }
}

/** ``true`` quando from > to (strings YYYY-MM-DD). */
export function isPeriodRangeInvalid(from, to) {
  return Boolean(from && to && from > to);
}
